import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Loading from "../Loading";
import Particle from "../Particle";
import GithubNew from "./GithubNew";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import { useTranslation } from "react-i18next";
import { useData } from "../../context/DataContext";
import { getImageURL } from "../../api";

function About() {
  const { profile, skills, loading } = useData();
  const { t } = useTranslation();

  const techSkills = skills.filter(
    (s) => s.category === "Frontend" || s.category === "Backend"
  );
  const toolSkills = skills.filter((s) => s.category === "Tools");

  const aboutTitle = profile?.about?.title || {};
  const lang = t("code") === "Code" ? "en" : "uz";

  if (loading) {
    return <Loading message="Loading About..." />;
  }

  return (
    <>
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                <strong className="purple">
                  {aboutTitle[lang] || t("about_heading", "Know Who I Am")}
                </strong>
              </h1>
              <Aboutcard profile={profile} />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img
                src={getImageURL(profile?.about?.image) || laptopImg}
                alt="about"
                className="img-fluid"
              />
            </Col>
          </Row>
          <h1 className="project-heading">
            {t("professional", "Professional")}{" "}
            <strong className="purple">{t("skillset", "Skillset")} </strong>
          </h1>

          <Techstack skills={techSkills.length > 0 ? techSkills : null} />

          <h1 className="project-heading">
            <strong className="purple">{t("tools", "Tools")}</strong>{" "}
            {t("i_use", "I use")}
          </h1>
          <Toolstack skills={toolSkills.length > 0 ? toolSkills : null} />

          <GithubNew username="saidqodirxon" />
        </Container>
      </Container>
    </>
  );
}

export default About;
